// Shared form utilities and validators for TanStack Form

// Email validator
export const emailValidator = ({ value }: { value: string }) => {
  if (!value) return 'Email is required';
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return 'Invalid email format';
  return undefined;
};

// Password validator (for registration)
export const passwordValidator = ({ value }: { value: string }) => {
  if (!value) return 'Password is required';
  if (value.length < 6) return 'Password must be at least 6 characters';
  return undefined;
};

// Required field validator
export const requiredValidator = (fieldName: string) => ({ value }: { value: string }) => {
  if (!value?.trim()) return `${fieldName} is required`;
  return undefined;
};
